/* -----------------Types--------------- */
import type { Confidence } from "@memorang/types";

import { Container } from "@memorang/ui";
/* -----------------Child components--------------- */
import BottomNavigationSession from "./BottomNavigationSession";
import ConfidenceSubmitButtons from "./ConfidenceSubmitButtons";
import NavButtons, { type NextButtonProps } from "./NavButtons";
import AIGenerateExplanationButton from "./SubmitAnswerAIFeedbackButton";

interface Props extends NextButtonProps {
	showConfidenceSubmitButtons?: boolean;
	onConfidenceProvided: (confidence: Confidence) => void;
	onAiFeedbackProvided: (confidence: Confidence) => void;
	progressText?: string;
	isSummativeTest?: boolean;
	toggleHelpDialog?: () => void;
	inReviewMode?: boolean;
	showSubmitAnswerAIFeedbackButton?: boolean;
	transcript?: string;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
}
const StudySessionBottomAppBar = ({
	handleNext,
	handlePrevious,
	showConfidenceSubmitButtons,
	onConfidenceProvided,
	progressText,
	isSummativeTest,
	toggleHelpDialog,
	inReviewMode,
	showSubmitAnswerAIFeedbackButton,
	transcript,
	onAiFeedbackProvided,
	handleTrackConfidenceClick,
	...rest
}: Props) => {
	return (
		<BottomNavigationSession isSummativeTest={isSummativeTest}>
			<Container fullWidth={isSummativeTest} maxWidth="sm">
				{showSubmitAnswerAIFeedbackButton ? (
					<AIGenerateExplanationButton
						onConfidenceProvided={onConfidenceProvided}
						onAiFeedbackProvided={onAiFeedbackProvided}
					/>
				) : showConfidenceSubmitButtons ? (
					<ConfidenceSubmitButtons
						onConfidenceProvided={onConfidenceProvided}
						handleTrackConfidenceClick={handleTrackConfidenceClick}
					/>
				) : (
					<NavButtons
						showButtonNavNext
						showButtonPrevious
						handleNext={handleNext}
						handlePrevious={handlePrevious}
						progressText={progressText}
						isSummativeTest={isSummativeTest}
						inReviewMode={inReviewMode}
						toggleHelpDialog={toggleHelpDialog}
						{...rest}
					/>
				)}
			</Container>
		</BottomNavigationSession>
	);
};

export default StudySessionBottomAppBar;
